<template>
  <div>
    <registration-steps
      v-if="systemStatus < 20 && isLoggedIn"
      class="top-bar__registration-steps"
    ></registration-steps>
    <div class="register">
      <div class="register__content">
        <spinner
          v-show="reg_form_loading"
          :animation-duration="1000"
          :size="60"
          :color="'#2E79EF'"
          style="margin:0 auto"
        />
        <div v-show="!reg_form_loading">
          <keep-alive>
            <router-view
              @loading-status="value => (reg_form_loading = value)"
              :user_profile="getUserProfile"
            />
          </keep-alive>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RegistrationSteps from "@/components/register/RegistrationSteps";

import RegFormMixin from "@/components/register_kyc/form_mixin.js";
import { mapGetters } from "vuex";
export default {
  name: "RegisterSectionView",
  data() {
    return {
      reg_form_loading: false,
      user_profile: {}
    };
  },
  mixins: [RegFormMixin],
  computed: {
    ...mapGetters(["getUserProfile"])
  },
  components: {
    RegistrationSteps
  },
  methods: {
    fetchData() {
      this.fetchUserProfileData();
      this.fetchCountryList();
      this.fetchDocumentTypesList();
    },
    fetchUserProfileData() {
      this.$store.dispatch("fetchUserProfile");
    }
  },
  beforeMount() {
    try {
      this.fetchData();
    } catch (e) {
      console.log(e);
    }
  }
};
</script>

<style>
.top-bar__registration-steps {
  padding: 30px 0px;
  background-color: #222b43;
}
.form__title {
  margin-bottom: 20px;
}

.form__input {
  margin-bottom: 15px;
}

.form__button {
  width: 100%;
  margin-top: 25px;
  padding: 20px 0;
  font-size: 14px;
}
/** select */
.select-container {
  display: flex;
  flex-direction: column;
}

.label {
  font-size: 15px;
  color: #ffffff;
}

.select {
  width: 100%;
  margin-top: 10px;
  height: 34px;
  padding: 20px 10px;
  font-size: 14px;
  color: #222c44;
  text-align: center;
  border-radius: 5px;
  outline: none;
  box-sizing: border-box;
}

.option {
  color: #000000;
  background-color: #ffffff;
}

.rep_minimize {
  cursor: pointer;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.2);
  padding: 13px;
  color: white;
  font-size: 13px;
  font-weight: 200;
  margin-top: 10px;
  transition: all 0.2s;
}
.rep_minimize:hover {
  transform: scale(1.05);
}
.rep_minimize.light {
  background-color: white;
  color: #1a75e9;
}
.rep_minimize.light > p {
  font-size: 20px;
}
.rep_minimize > .rep_title {
  font-size: 20px;
}

.login-form__error {
  margin: 10px 0px;
  color: #ef4748;
}

.segment {
  display: inline-block;
  box-sizing: border-box;
  width: 48%;
  margin: 1%;
  padding: 15px 15px 10px;
  border-radius: 5px;
  color: white;
  border: 2px solid #2e79ef;
  opacity: 0.4;
  cursor: pointer;
  transition: opacity 0.1s;
}
.segment:hover {
  opacity: 0.7;
}
.segment.active {
  opacity: 1;
}

.horizontal-line {
  border: 0.5px solid rgba(255, 255, 255, 0.3);
  border-style: dashed;
  opacity: 0.6;
  width: 95%;
  margin: 20px auto;
}

.register {
  height: auto;
  /*display: flex;*/
  align-items: center;
  min-height: 90vh;
  padding: 20px 0;
  background-color: #222c44;
  box-sizing: border-box;
}

.register__content {
  width: 30%;
  margin: 50px auto;
}

.pane {
  background-color: rgba(0, 0, 0, 0.2);
  color: white;
  padding: 12px 15px 10px;
  margin-top: 5px;
  border-radius: 5px;
  word-break: break-all;
}
.pane-list-del {
  cursor: pointer;
  text-align: right;
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
}

.pane-list-add {
  float: right;
  margin: -5px 0px 0px;
  cursor: pointer;
  color: #2e79ef;
}

@media all and (max-width: 1300px) {
  .register__content {
    width: 40%;
  }
}

@media all and (max-width: 1000px) {
  .register__content {
    width: 50%;
  }
}

@media all and (max-width: 650px) {
  .register__content {
    width: 70%;
  }
}

@media all and (max-width: 400px) {
  .register__content {
    width: 85%;
  }
}
</style>
